// icon background
const IconBackground = () => {
    return (
        <svg className="icon-background" width="176" height="176" viewBox="0 0 176 176" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M136.476 129.91C129.798 147.507 116.638 161.411 99.5739 169.033C82.5099 176.656 63.3729 177.18 45.9368 170.355C28.3811 163.57 14.4739 150.293 6.8047 133.125C-0.864539 115.957 -1.48434 96.7442 5.18845 79.1361L7.62695 72.7014C14.9385 58.2749 26.5943 46.9354 41.049 40.4784L176 0.500001L136.476 129.91Z" fill="none" stroke="white" strokeWidth="1" opacity='30%' />
        </svg>
    )
  };
  
  export default IconBackground;